import {
  collection,
  selection,
} from 'common/store/actions';

export const NAMESPACE = 'JOB/JOBS';
export const PURGE = `${NAMESPACE}/PURGE`;
export const SHOW_CREATE_JOB_DIALOG = `${NAMESPACE}/SHOW_CREATE_JOB_DIALOG`;
export const DUPLICATE_JOB_CHECK = `${NAMESPACE}/DUPLICATE_JOB_CHECK`;
export const DUPLICATE_JOB_CHECK_SUCCESS = `${NAMESPACE}/DUPLICATE_JOB_CHECK_SUCCESS`;
export const DUPLICATE_JOB_CHECK_ERROR = `${NAMESPACE}/DUPLICATE_JOB_CHECK_ERROR`;
export const RESET_DUPLICATE_JOB_CHECK = `${NAMESPACE}/RESET_DUPLICATE_JOB_CHECK`;
export const SAVE_STEP1_DETAILS = `${NAMESPACE}/SAVE_STEP1_DETAILS`;
export const CHECK_FOR_METER_EXISTENCE = `${NAMESPACE}/CHECK_FOR_METER_EXISTENCE`;
export const CHECK_FOR_METER_EXISTENCE_SUCCESS = `${NAMESPACE}/CHECK_FOR_METER_EXISTENCE_SUCCESS`;
export const CHECK_FOR_METER_EXISTENCE_ERROR = `${NAMESPACE}/CHECK_FOR_METER_EXISTENCE_ERROR`;
export const RESET_METER_EXISTENCE_CHECK = `${NAMESPACE}/RESET_METER_EXISTENCE_CHECK`;
export const SAVE_STEP2_DETAILS = `${NAMESPACE}/SAVE_STEP2_DETAILS`;
export const RESET_STEP2_DETAILS = `${NAMESPACE}/RESET_STEP2_DETAILS`;
export const SAVE_STEP3_DETAILS = `${NAMESPACE}/SAVE_STEP3_DETAILS`;
export const RESET_STEP3_DETAILS = `${NAMESPACE}/RESET_STEP3_DETAILS`;
export const SAVE_STEP4_DETAILS = `${NAMESPACE}/SAVE_STEP4_DETAILS`;
export const RUN_GET_JOB = `${NAMESPACE}/RUN_GET_JOB`;
export const RUN_GET_JOB_SUCCESS = `${NAMESPACE}/RUN_GET_JOB_SUCCESS`;
export const RUN_GET_JOB_ERROR = `${NAMESPACE}/RUN_GET_JOB_ERROR`;
export const SHOW_PREVIEW_JOB_DIALOG = `${NAMESPACE}/SHOW_PREVIEW_JOB_DIALOG`;


const collectionActions = collection.factory(NAMESPACE);
const selectionActions = selection.factory(NAMESPACE);

export const {
  LOAD,
  UPDATE,
  LOAD_SUCCESS,
  LOAD_ERROR,
  TOGGLE_SORT,
  PAGINATION_CHANGE,
  SEARCH,
  ADVANCED_SEARCH,
  DOWNLOAD,
  DOWNLOAD_SUCCESS,
  DOWNLOAD_ERROR,
  CLEAR,
} = collectionActions.TYPES;

export const {
  SET_SELECTED,
  CLEAR_SELECTED,
} = selectionActions.TYPES;

export const {
  setSelected,
  clearSelected,
} = selectionActions;

export const {
  load,
  loadSuccess,
  loadError,
  toggleSort,
  update,
  search,
  paginationChange,
  advancedSearch,
  download,
  downloadSuccess,
  downloadError,
  } = collectionActions;

export const purge = jobId => ({
  type: PURGE,
  jobId,
});

export const showCreateJobDialog = (flag) => ({
  type: SHOW_CREATE_JOB_DIALOG,
  flag,
});

export const duplicateJobCheck = (jobName, jobDetails, stepper, saveStep1Details) => ({
  type: DUPLICATE_JOB_CHECK,
  jobName,
  jobDetails,
  stepper,
  saveStep1Details,
});

export const duplicateJobCheckSuccess = (response) => ({
  type: DUPLICATE_JOB_CHECK_SUCCESS,
  response
});

export const duplicateJobCheckError = (err) => {
  return {
    type: DUPLICATE_JOB_CHECK_ERROR,
    error: err.response,
  };
};

export const resetDuplicateJobCheck = () => {
  return {
    type: RESET_DUPLICATE_JOB_CHECK,
  };
};

export const saveStep1Details = (jobDetails) => {
  return {
    type: SAVE_STEP1_DETAILS,
    jobDetails
  }
}

export const checkForMeterExistence = (groupDetails, stepper, saveStep2Details) => {
  return {
    type: CHECK_FOR_METER_EXISTENCE,
    groupDetails,
    stepper,
    saveStep2Details,
  }
}

export const checkForMeterExistenceSuccess = (response) => ({
  type: CHECK_FOR_METER_EXISTENCE_SUCCESS,
  response
});

export const checkForMeterExistenceError = (err) => ({
    type: CHECK_FOR_METER_EXISTENCE_ERROR,
    error: err,
});

export const resetMeterExistenceCheck = () => ({
    type: RESET_METER_EXISTENCE_CHECK,
});

export const saveStep2Details = (details) => {
  return {
    type: SAVE_STEP2_DETAILS,
    details
  }
}

export const resetstep2Details = () => {
  return {
    type: RESET_STEP2_DETAILS,
  };
};

export const saveStep3Details = (details) => {
  return {
    type: SAVE_STEP3_DETAILS,
    details,
  }
}

export const resetstep3Details = () => {
  return {
    type: RESET_STEP3_DETAILS,
  };
};

export const saveStep4Details = (details) => {
  return {
    type: SAVE_STEP4_DETAILS,
    details,
  }
}

export const runGetJob = (payload) => {
  return {
    type: RUN_GET_JOB,
    payload,
  }
}

export const runGetJobSuccess = () => ({
  type: RUN_GET_JOB_SUCCESS,
});

export const runGetJobError = () => {
  return {
    type: RUN_GET_JOB_ERROR,
  };
};

export const showPreviewJobDialog = (flag) => {
  return {
    type: SHOW_PREVIEW_JOB_DIALOG,
    flag
  };
};
